<template>
  <Section
    @back="$emit('back')"
    title="対象自動車設定"
    margin
    tip-message="対象自動車設定に戻る"
  >
    <template>
      <v-subheader>{{ extractionConditionStr }}</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ targetStr }}
        </v-flex>
      </v-layout>
    </template>
    <template v-if="uploadFileName">
      <v-subheader>アップロードファイル</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ uploadFileName }}
        </v-flex>
      </v-layout>
    </template>
    <CampaignModalPageConfirmArea :menuSetting="menuSetting" />
    <template v-if="menuSetting.memo !== ''">
      <v-subheader>備考</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ menuSetting.memo }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import Section from './CampaignModalPageConfirmSection'
import CampaignModalPageConfirmArea from './CampaignModalPageConfirmArea'

export default {
  name: 'CampaignModalPageConfirmAutomobileTarget',
  components: {
    Section,
    CampaignModalPageConfirmArea,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    uploadFileName() {
      return this.form.campaign.menuSetting.uploadFile.fileName
    },
    extractionConditionStr() {
      switch (this.menuSetting.extractionCondition) {
        case 'car_type':
          return '登録車種'
        case 'domestic_imported_car_classification':
          return '国産車/輸入車'
        case 'brand_or_car_name':
          return 'ブランド・車名'
        case 'first_registration_year_month':
          return '初度登録年月'
        case 'vehicle_inspection_expiration':
          return '車検満了年月'
        case 'mileage':
          return '走行距離'
        default:
          return ''
      }
    },
    targetStr() {
      switch (this.menuSetting.extractionCondition) {
        case 'car_type':
          return this.menuSetting.targetCarType.carTypes
            .map(carType => this.getCarTypeStr(carType))
            .join(' ,')
        case 'domestic_imported_car_classification':
          return this.menuSetting.targetDomesticImportedCarClassification
            .domesticImportedCarClassification === 'domestic'
            ? '国産車'
            : '輸入車'
        case 'brand_or_car_name':
          return this.menuSetting.targetBrandOrCarName.brandNames.join(', ')
        case 'first_registration_year_month': {
          const target = this.menuSetting.targetFirstRegistrationYearMonth
          return (
            this.getYearMonthStr(target.startYear, target.startMonth) +
            ' ~ ' +
            this.getYearMonthStr(target.endYear, target.endMonth)
          )
        }
        case 'vehicle_inspection_expiration': {
          const target = this.menuSetting.targetVehicleInspectionExpiration
          return (
            this.getYearMonthStr(target.startYear, target.startMonth) +
            ' ~ ' +
            this.getYearMonthStr(target.endYear, target.endMonth)
          )
        }
        case 'mileage': {
          const target = this.menuSetting.targetMileage
          return (
            this.getMileageStr(target.minMileage) +
            ' ~ ' +
            this.getMileageStr(target.maxMileage)
          )
        }
        default:
          return ''
      }
    },
  },
  methods: {
    getCarTypeStr(carType) {
      switch (carType) {
        case 'regular_passenger_car':
          return '普通乗用車'
        case 'light_passenger_car':
          return '軽乗用車'
        case 'truck':
          return '貨物車両'
        case 'special_car':
          return '特殊車両'
      }
    },
    getYearMonthStr(year, month) {
      if (year === null) {
        return '2000年以前'
      }
      return year + '年' + month + '月'
    },
    getMileageStr(value) {
      if (value === 0) {
        return '0km'
      }
      if (value === null) {
        return '上限なし'
      }
      return value + '万km'
    },
  },
}
</script>
